import { z } from "zod";
export const releaseCautionSchema = z
    .object({
    retained_amount: z.number().int().min(0),
    release_note: z.string().max(2000).optional(),
})
    .refine((data) => data.retained_amount === 0 || (data.release_note !== undefined && data.release_note.trim().length > 0), {
    message: "Une note est obligatoire si vous retenez un montant.",
    path: ["release_note"],
});
